import { render, staticRenderFns } from "./TripleceViral.vue?vue&type=template&id=8acfa334"
import script from "./TripleceViral.vue?vue&type=script&lang=js"
export * from "./TripleceViral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports